import { Injectable } from '@angular/core';
import { HttpUtilityService } from './http-utility.service';
import { map, Observable } from 'rxjs';
import { apiEndpoints } from '../constants/api-endpoints';
import { HttpResponse } from '@angular/common/http';
import { UserAccessDetails } from '../interface/user';

@Injectable({
  providedIn: 'root',
})
export class UserAccessService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  public getUserAccess(): Observable<{
    body: UserAccessDetails;
    status: number;
  }> {
    const url = apiEndpoints.userAccess;
    return this.httpUtilityService
      .get<HttpResponse<UserAccessDetails>>(url, { observe: 'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          return {
            body: response.body || [],
            status: response.status,
          };
        })
      );
  }
}
